var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadedFileError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18C2 9.16344 9.16344 2 18 2C26.8366 2 34 9.16344 34 18C34 26.8366 26.8366 34 18 34C9.16344 34 2 26.8366 2 18Z",
    fill: "#FEE4E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 11.3333H14C13.6464 11.3333 13.3073 11.4738 13.0572 11.7238C12.8072 11.9739 12.6667 12.313 12.6667 12.6666V23.3333C12.6667 23.6869 12.8072 24.0261 13.0572 24.2761C13.3073 24.5262 13.6464 24.6666 14 24.6666H22C22.3536 24.6666 22.6928 24.5262 22.9428 24.2761C23.1929 24.0261 23.3334 23.6869 23.3334 23.3333V16M18.6667 11.3333L23.3334 16M18.6667 11.3333V16H23.3334",
    stroke: "#D92D20",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32C10.268 32 4 25.732 4 18H0C0 27.9411 8.05887 36 18 36V32ZM32 18C32 25.732 25.732 32 18 32V36C27.9411 36 36 27.9411 36 18H32ZM18 4C25.732 4 32 10.268 32 18H36C36 8.05887 27.9411 0 18 0V4ZM18 0C8.05887 0 0 8.05887 0 18H4C4 10.268 10.268 4 18 4V0Z",
    fill: "#FEF3F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedFileError);
export default __webpack_public_path__ + "static/media/uploaded-file-error.380bc50ddb35e7b03870350b32ca050a.svg";
export { ForwardRef as ReactComponent };